import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import dayjs from 'dayjs';

import Colors from '../../constants/Colors';
import tefap from '../../utils/tefap';
import TefapAttestation from './TefapAttestation/TefapAttestation';
import FilledButton from '../FilledButton';
import Svg from '../Svg';
import { pantryDetailsPromptStyleSheet } from './pantryDetailsPromptStyleSheet';
import { useLocalization } from '../../store/utils/useLocalization';

import { AppText } from '../AppText';

function TefapStatus(props) {
  const { actions, registration, pantry } = props;
  const [isTefapVisible, setIsTefapVisible] = useState(false);
  const { translation, t } = useLocalization();

  const { user: profile, tefapConfig } = registration;
  const { tefap_expiration_date } = profile;
  const { id: pantryId, nextVisit: visit } = pantry || {};
  let tefapStatus = tefap.getTefapStatus(profile);
  if (visit && visit.id && visit.tefap_attestation == null) {
    tefapStatus = 'incomplete';
  }
  const expiration = tefap_expiration_date ? tefap_expiration_date : 'tbd';
  const programName = t('tefap_form');

  let showTefapStatus = false;
  let tefapDescription = null;
  let tefapButtonLabel = null;
  let tefapButton = null;
  let tefapIconName = null;
  let tefapIconColor = null;

  const tefapReason = tefap.getTefapReason(profile, translation, tefapConfig);
  const productReason = `${t('tefap_receive_product')} ${t('because')} ${tefapReason.reason}`;

  switch (tefapStatus) {
    case 'expired':
      showTefapStatus = true;
      tefapIconName = 'unverified';
      tefapIconColor = pantryDetailsPromptStyleSheet.icon.color;
      tefapDescription = `${t('tefap_form_expired')} ${dayjs(expiration).format('MM/DD/YYYY')}`;
      tefapButtonLabel = t('tefap_retake');
      break;
    case 'ineligible':
      showTefapStatus = true;
      tefapIconName = 'unverified';
      tefapIconColor = pantryDetailsPromptStyleSheet.icon.color;
      tefapDescription = `${t('tefap_not_eligible')} ${productReason}`;
      tefapButtonLabel = t('tefap_retake');
      break;
    case 'eligible':
      showTefapStatus = true;
      tefapIconName = 'verified';
      tefapIconColor = Colors.accentColor;
      tefapDescription = `${t('tefap_eligible')} ${productReason}`;
      break;
    case 'incomplete':
    case 'not_signed':
    default:
      showTefapStatus = true;
      tefapIconName = 'unverified';
      tefapIconColor = pantryDetailsPromptStyleSheet.icon.color;
      tefapDescription = t('pantry_details_prompt_visit_label', { programName });
      tefapButtonLabel = t('program_complete_now');
      break;
  }

  if (tefapButtonLabel) {
    tefapButton = (
      <FilledButton
        onPress={() => setIsTefapVisible(true)}
        color={pantryDetailsPromptStyleSheet.button.color}
        label={tefapButtonLabel}
        full={false}
        paddingHorizontal={pantryDetailsPromptStyleSheet.button.paddingHorizontal}
      />
    );
  }

  return (
    <View style={pantryDetailsPromptStyleSheet.view}>
      {showTefapStatus ? (
        <View style={pantryDetailsPromptStyleSheet.container}>
          <View style={pantryDetailsPromptStyleSheet.leftContainer}>
            <Svg
              icon={tefapIconName}
              color={tefapIconColor}
              width={pantryDetailsPromptStyleSheet.icon.width}
              height={pantryDetailsPromptStyleSheet.icon.height}
            />
            <View style={pantryDetailsPromptStyleSheet.promptContainer}>
              <AppText style={pantryDetailsPromptStyleSheet.text}>
                {t('pantry_details_prompt_title', {
                  programName,
                })}
              </AppText>
              <View style={pantryDetailsPromptStyleSheet.promptLabelContainer}>
                <AppText style={pantryDetailsPromptStyleSheet.promptLabel}>{tefapDescription}</AppText>
              </View>
            </View>
          </View>
          <View style={pantryDetailsPromptStyleSheet.buttonContainer}>{tefapButton}</View>
        </View>
      ) : null}
      {isTefapVisible ? (
        <TefapAttestation
          isVisible={isTefapVisible}
          onCancel={() => setIsTefapVisible(false)}
          translation={translation}
          registration={registration}
          actions={actions}
          visit={visit}
          pantry={pantry}
          organizationId={props.organizationId}
        />
      ) : null}
    </View>
  );
}

TefapStatus.propTypes = {
  registration: PropTypes.objectOf(PropTypes.any).isRequired,
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  pantry: PropTypes.objectOf(PropTypes.any),
  organizationId: PropTypes.number.isRequired,
};

export default TefapStatus;
